var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9983 1.74689C11.2762 1.60795 11.6141 1.72058 11.753 1.99844L13.4039 5.30019C14.4187 5.37814 15.0555 5.5772 15.4664 6.08548C15.793 6.48941 15.8987 6.99194 15.8598 7.6875H2.13997C2.10114 6.99194 2.20683 6.48941 2.53338 6.08548C2.94427 5.57721 3.58108 5.37815 4.59589 5.30019L6.24676 1.99844C6.38569 1.72058 6.72357 1.60795 7.00144 1.74689C7.2793 1.88582 7.39192 2.2237 7.25299 2.50156L5.8768 5.25395C6.23921 5.25 6.63466 5.25 7.06635 5.25H10.9335C11.3651 5.25 11.7606 5.25 12.123 5.25395L10.7468 2.50156C10.6078 2.2237 10.7205 1.88582 10.9983 1.74689Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66624 10.6929C2.51098 9.96838 2.3781 9.34824 2.28373 8.8125H15.7161C15.6217 9.34823 15.4888 9.96835 15.3336 10.6928L15.0121 12.1929C14.6469 13.8973 14.4643 14.7495 13.8455 15.2498C13.2267 15.75 12.3551 15.75 10.612 15.75H7.38777C5.64467 15.75 4.77312 15.75 4.15432 15.2498C3.53551 14.7495 3.3529 13.8973 2.98766 12.1929L2.66624 10.6929ZM7.49988 9.9375C7.18922 9.9375 6.93738 10.1893 6.93738 10.5C6.93738 10.8107 7.18922 11.0625 7.49988 11.0625H10.4999C10.8105 11.0625 11.0624 10.8107 11.0624 10.5C11.0624 10.1893 10.8105 9.9375 10.4999 9.9375H7.49988Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.42e193be.svg";
export { ForwardRef as ReactComponent };